"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ts_validators_1 = require("ts-validators");
const valueIsControlsFontSizeGlobal = (0, ts_validators_1.buildValueIsShape)('FontSizeGlobal', {
    type: (0, ts_validators_1.buildValueIsConstant)('global'),
});
exports.default = valueIsControlsFontSizeGlobal;
